import { LogOut, ExternalLink, User, Building2 } from 'lucide-react'
import { clearTokens } from '@/lib/storage'
import { getStorage } from '@/lib/storage'
import { APP_BASE_URL } from '@/lib/constants'

interface SettingsScreenProps {
  onSignOut: () => void
}

export function SettingsScreen({ onSignOut }: SettingsScreenProps) {
  const storage = getStorage()
  const org = storage.pairedOrg
  const user = storage.pairedUser
  const pairedAt = storage.pairedAt

  const userName = user
    ? [user.nameFirst, user.nameLast].filter(Boolean).join(' ') || null
    : null

  function handleSignOut() {
    clearTokens()
    onSignOut()
  }

  return (
    <div className="flex flex-col h-full overflow-y-auto">
      <div className="p-4 space-y-4">
        <h2 className="text-sm font-semibold text-secondary-700">Add-in Settings</h2>

        {/* Paired account */}
        <div className="rounded-lg border border-secondary-200 divide-y divide-secondary-100">
          {userName && (
            <div className="flex items-center gap-3 px-4 py-3">
              <User size={14} className="text-secondary-400 shrink-0" />
              <div className="min-w-0">
                <p className="text-xs text-secondary-500">Signed in as</p>
                <p className="text-sm font-medium text-secondary-900 truncate">{userName}</p>
              </div>
            </div>
          )}

          {org && (
            <div className="flex items-center gap-3 px-4 py-3">
              <Building2 size={14} className="text-secondary-400 shrink-0" />
              <div className="min-w-0">
                <p className="text-xs text-secondary-500">Organization</p>
                <p className="text-sm font-medium text-secondary-900 truncate">{org.name}</p>
              </div>
            </div>
          )}

          {pairedAt && (
            <div className="px-4 py-3">
              <p className="text-xs text-secondary-400">
                Paired on {new Date(pairedAt).toLocaleDateString()}
              </p>
            </div>
          )}
        </div>

        {/* Links */}
        <div className="space-y-1">
          <a
            href={`${APP_BASE_URL}/settings/general`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-secondary-50 transition-colors text-sm text-secondary-700"
          >
            Manage in Athenty
            <ExternalLink size={13} className="text-secondary-400" />
          </a>
          <a
            href="https://docs.athenty.com/docs/outlook-add-in/getting-started"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-secondary-50 transition-colors text-sm text-secondary-700"
          >
            Documentation
            <ExternalLink size={13} className="text-secondary-400" />
          </a>
        </div>

        {/* Sign out */}
        <button
          onClick={handleSignOut}
          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium text-error-DEFAULT border border-error-DEFAULT/20 hover:bg-error-DEFAULT/5 transition-colors"
        >
          <LogOut size={14} />
          Sign out
        </button>

        {/* Version */}
        <p className="text-center text-xs text-secondary-300">
          Matter Planner Outlook Add-in v1.0.0
        </p>
      </div>
    </div>
  )
}
